import {debounce, DebouncedFunc, get} from 'lodash';
import {ChangeEvent, MouseEvent} from 'react';
import {create} from 'zustand';
import {persist} from 'zustand/middleware';

export interface ContractRequestData {
  rowsPerPage: number;
  page: number;
  counter?: number;
  id: string;
}

interface ContractRequestState {
  data: ContractRequestData;
  setContractRequestCounter: (counter?: number) => void;
  changeContractRequestId: DebouncedFunc<(e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void>;
  changeContractRequestTablePage: (e: MouseEvent<HTMLButtonElement> | null, page: number) => void;
  changeContractRequestTableRowsPerPage: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const useContractRequestStore = create<ContractRequestState>()(
  persist(
    (set) => ({
      data: {page: 0, rowsPerPage: 5, id: ''},
      setContractRequestCounter: (counter) => set((state) => ({data: {...state.data, counter}})),
      changeContractRequestId: debounce((e) => {
        set((state) => ({data: {...state.data, id: e.target.value, page: 0}}));
      }, 600),
      changeContractRequestTablePage: (_, page) => set((state) => ({data: {...state.data, page}})),
      changeContractRequestTableRowsPerPage: (e) =>
        set((state) => ({data: {...state.data, rowsPerPage: parseInt(e.target.value, 10)}})),
    }),
    {
      name: 'contract-request-pagination-store',
      partialize: (state) => ({data: {...state.data, rowsPerPage: state.data.rowsPerPage}}),
      merge: (persistedState, currentState) => ({
        ...currentState,
        data: {
          ...currentState.data,
          rowsPerPage: get(persistedState, 'data.rowsPerPage', currentState.data.rowsPerPage),
        },
      }),
    },
  ),
);

export const {
  changeContractRequestId,
  changeContractRequestTablePage,
  changeContractRequestTableRowsPerPage,
  setContractRequestCounter,
} = useContractRequestStore.getState();
